export const addressMessages = {
  'address.add': '新增地址',
  'address.addSuccess': '地址添加成功',
  'address.addTitle': '新增地址',
  'address.default': '默认',
  'address.deleteConfirm': '确定删除该地址吗？',
  'address.deleteFail': '删除失败',
  'address.deleteSuccess': '地址已删除',
  'address.deleteTitle': '删除地址',
  'address.editTitle': '编辑地址',
  'address.empty': '暂无收货地址',
  'address.formIncomplete': '请填写完整信息',
  'address.label.city': '城市',
  'address.label.detail': '详细地址',
  'address.label.district': '区县',
  'address.label.phone': '手机号',
  'address.label.province': '省份',
  'address.label.recipient': '收件人',
  'address.ph.city': '请输入城市',
  'address.ph.detail': '请输入街道、门牌号等',
  'address.ph.district': '请输入区县',
  'address.ph.phone': '请输入手机号',
  'address.ph.province': '请输入省份',
  'address.ph.recipient': '请输入收件人姓名',
  'address.saveFail': '保存失败',
  'address.setDefault': '设为默认',
  'address.setDefaultFail': '设置默认地址失败',
  'address.setDefaultSuccess': '已设为默认地址',
  'address.title': '收货地址',
  'address.updateSuccess': '地址更新成功',
};
